// extracted by mini-css-extract-plugin
module.exports = {"main":"table_main__IkOHA","tableflex":"table_tableflex__3Co_n"};